/**
 * Map management hook
 * Handles map-related state (markers, selected item)
 * NOTE: Camera state (center/zoom) is now managed locally in ExploreMap
 * to prevent re-renders of other views during map interaction
 */

export function useExploreMap(state, dispatch) {
  // Set selected item
  const setSelectedItem = (item) => {
    dispatch({ type: 'SET_SELECTED_ITEM', payload: item });
  };

  return {
    markers: state.markers,
    selectedItem: state.selectedItem,
    setSelectedItem,
  };
}
